import { format } from '@utils/string';
import getInstance from '@services/axios';
import { getAreaURL } from '@services/urls/apiGatewayURLs';
import { keysToCamel } from '@utils/object';
import ServiceResponse from './models/ServiceResponse';
import { locationURL } from './urls/apiURLs';

const adaptResponse = ({ areaId, areaName, cityId, cityName }) => ({
  area: {
    id: areaId,
    name: areaName,
  },
  city: {
    id: cityId,
    name: cityName,
  },
});

export async function saveSearchedLocation({ axios, location }) {
  try {
    await axios.post(locationURL, { location });
    return new ServiceResponse({ success: true });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export async function getLocationCity({ latitude, longitude, countryId }) {
  try {
    if (!latitude || !longitude || !countryId) {
      return new ServiceResponse({
        error: 'countryId, latitude and longitude params are required',
      });
    }

    const { data } = await getInstance().get(
      format(getAreaURL, countryId, latitude, longitude),
    );

    const locationData =
      data.data.length > 0 ? adaptResponse(keysToCamel(data.data[0])) : {};

    const response = locationData?.city
      ? { data: locationData }
      : { success: false, error: 'point does not belong to any country' };

    return new ServiceResponse(response);
  } catch (error) {
    return new ServiceResponse({ error });
  }
}
